module.exports = __webpack_public_path__ + "static/media/riverside.4ffd6888.png";